import { addRest, number_or_0, objectid_array_or_empty, string_or_empty, } from '../../utils/parser-utils';
import { ObjectLine } from 'z3k-parser/parser/utils/object-line';
const output_actions = [
    { name: 'name', ...string_or_empty },
    { name: 'physical_output', ...number_or_0 },
    // {name: 'action', ...string_or_empty},
    { name: 'turn_on_delay', ...number_or_0 },
    { name: 'blink_pulses_len', ...number_or_0 },
    { name: 'lower_priority_actions_output_list', ...objectid_array_or_empty },
    //TODO: там object
    // {name: 'timetable', ...string_or_empty},
    { name: 'blink_pulses_period', ...number_or_0 },
    { name: 'analog_value', ...number_or_0 },
];
function outputActions2Str(obj_id, obj) {
    const action_type = obj.action.type;
    let raw_active_state_time;
    switch (action_type) {
        case 0:
        case 1:
            raw_active_state_time = action_type;
            break;
        case 3:
            raw_active_state_time = 0xffffffff;
            break;
        default:
            raw_active_state_time = Math.round(obj.action.duration * 1000);
    }
    return new ObjectLine(obj.id, 5, [
        obj.name,
        obj.physical_output === -1 ? 255 : obj.physical_output,
        raw_active_state_time,
        Math.round(obj.turn_on_delay * 1000),
        Math.round(obj.blink_pulses_len * 1000),
        obj.lower_priority_actions_output_list,
        obj.timetable.checked ? Number(obj.timetable.weekday_register) : 0,
        obj.timetable.checked ? Number(obj.timetable.time) : 0,
        Math.round(obj.blink_pulses_period * 1000),
        Math.round(obj.analog_value || 0),
        ...(obj.rest || []),
    ]);
}
function outputActionsFromStr(id, params) {
    const raw_active_state_time = Number(params[2]);
    let action_type;
    switch (raw_active_state_time) {
        case 0:
        case 1:
            action_type = raw_active_state_time;
            break;
        case 0xffffffff:
            action_type = 3;
            break;
        default:
            action_type = 2;
    }
    return {
        id: id,
        name: params[0],
        physical_output: params[1] === 255 ? -1 : params[1],
        action: {
            type: action_type,
            duration: action_type !== 2 ? 0.5 : raw_active_state_time / 1000,
        },
        turn_on_delay: params[3] / 1000,
        blink_pulses_len: params[4] / 1000,
        lower_priority_actions_output_list: params[5],
        timetable: {
            //@ts-ignore
            checked: params[6] > 0,
            weekday_register: Number(params[6]),
            time: Number(params[7]),
        },
        blink_pulses_period: params.length > 8 ? params[8] : 0,
        analog_value: params[9] || 0,
        ...addRest(params, 10),
    };
}
export const output_actions_parser = {
    toStr: outputActions2Str,
    fromStr: outputActionsFromStr,
};
